export enum PercentageStatus {
  GROW = "grow",
  NEUTRAL = "neutral",
  DECLINE = "decline",
}
